module.exports = __webpack_public_path__ + "static/media/studynightCol.435ffab4.png";